import { ReactNode } from 'react';
import * as Styles from './CompetencyBox.styles';

export type CompetencyBoxProps = {
  name: string;
  weight: number;
  isReviewed: boolean;
  children: ReactNode;
};

export default function CompetencyBox({
  name,
  isReviewed,
  weight,
  children,
}: CompetencyBoxProps): JSX.Element {
  return (
    <Styles.Box isReviewed={isReviewed}>
      <Styles.Header>
        <Styles.CompetencyNameWrapper>
          <Styles.CompetencyName>{name}</Styles.CompetencyName>
          <Styles.CompetencyWeight>(weight: {weight})</Styles.CompetencyWeight>
        </Styles.CompetencyNameWrapper>

        <Styles.ActionLabel>Fill Below</Styles.ActionLabel>
      </Styles.Header>

      {children}
    </Styles.Box>
  );
}
